var map = {
	"./app.json": 446,
	"./blog.json": 447,
	"./components.json": 448,
	"./conversionTable.json": 449,
	"./currency.json": 450,
	"./currencyBRL.json": 451,
	"./currencyUSD.json": 452,
	"./cxi-old.json": 453,
	"./events.json": 454,
	"./form.json": 455,
	"./glossary.json": 456,
	"./home.json": 457,
	"./iframe.json": 458,
	"./login.json": 459,
	"./logout.json": 460,
	"./matches.json": 461,
	"./menu.json": 462,
	"./news.json": 463,
	"./notifications.json": 464,
	"./oiweek.json": 465,
	"./pages.json": 466,
	"./profile.json": 467,
	"./ranking-BKP.json": 468,
	"./ranking.json": 469,
	"./register.json": 470,
	"./startupId.json": 471,
	"./support.json": 472,
	"./translation.json": 473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 445;